import type {
  IContactFindOneByIdRequest,
  IContactFindOneByIdResponse,
} from '@bb/contacts';
import axios from 'axios';

const getContactById = async (contactId: string) => {
  const config: IContactFindOneByIdRequest = {
    url: `/contacts/${contactId}`,
    method: 'get',
  };

  const { data } = await axios.request<IContactFindOneByIdResponse>(config);
  return data;
};

export default getContactById;
